import { Grid } from "@mui/material"
import "./styles.scss"


export function MetricCardsContainer({ children, loading }: { loading?: boolean, children: any }) {
    return <Grid container className={`metricCardsContainer ${loading ? "loading" : ""}`}>
        {children}
    </Grid>
}